import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getContactData } from '../../../Public/contact-data.js';
import ZohoService from '../../../Services/ZohoService';
import ContactService from '../../../Services/ContactService.js';

// Custom Components
import { ButtonPrimary, ButtonSecondary } from '../../Buttons/button-component.js';
import { InputComponent } from '../../Inputs/input-component.js';

const ContactFormLightweight = ({ onSuccess, subject = 'Quick Lead from Website' }) => {
    // 1. Global State
    const { language = 'he', dir } = useSelector((state) => state.systemData || {});
    const navigate = useNavigate();

    // 2. Data Source
    const data = getContactData(language);
    const txt = data.lightweightForm;

    // 3. Local State
    const [formData, setFormData] = useState({
        email: '',
        fullName: '',
        phone: ''
    });
    const [status, setStatus] = useState('idle');

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.email && !formData.phone) {
            alert(txt.errorMsg);
            return;
        }

        setStatus('loading');

        const { email, fullName, phone } = formData;
        const parts = fullName.trim().split(/\s+/);
        const firstName = parts[0] || 'Unknown';
        const lastName = parts.slice(1).join(' ') || '';

        try {
            // 1. Flowma backend, creates internal lead + sends email
            await ContactService.sendContact({
                fullName, email, phone,
                subject,
                message: `Lightweight form submission${subject ? `, ${subject}` : ''}`
            });

            // 2. Old Zoho API, kept for reference, replaced by backend webhook
            // ZohoService.createLead({
            //     email, fullName, phone,
            //     company: 'Quick Lead',
            //     leadSource: txt.leadSource
            // }).catch(err => console.warn(err));

            setStatus('success');
            if (onSuccess) onSuccess();

            setFormData({ email: '', fullName: '', phone: '' });
            navigate('/thank-you');

        } catch (error) {
            setStatus('idle');
        }
    };

    return (
        <form dir={dir} className="w-full flex flex-col gap-4" onSubmit={handleSubmit}>
            <h3 className="text-xl font-bold mb-1 hidden">{txt.title}</h3>

            <InputComponent
                size="lg"
                placeholder={txt.placeholders.name}
                value={formData.fullName}
                onChange={(e) => handleChange('fullName', e.target.value)}
                required
                className="!bg-white !text-zinc-900 !border !border-zinc-200 rounded-xl placeholder:!text-zinc-500 shadow-sm"
            />

            <InputComponent
                size="lg"
                type="tel"
                placeholder={txt.placeholders.phone}
                value={formData.phone}
                onChange={(e) => handleChange('phone', e.target.value)}
                className="!bg-white !text-zinc-900 !border !border-zinc-200 rounded-xl placeholder:!text-zinc-500 shadow-sm"
            />

            <InputComponent
                size="lg"
                type="email"
                dir="ltr"
                className={`!bg-white !text-zinc-900 !border !border-zinc-200 rounded-xl placeholder:!text-zinc-500 shadow-sm ${dir === 'rtl' ? 'text-right' : 'text-left'}`}
                placeholder={txt.placeholders.email}
                value={formData.email}
                onChange={(e) => handleChange('email', e.target.value)}
            />

            <ButtonSecondary
                type="submit"
                fullWidth
                size="lg"
                className="shadow-md mt-2 flex justify-center items-center gap-2"
                disabled={status === 'loading'}
            >
                <span>{status === 'loading' ? txt.sendingLabel : txt.submitLabel}</span>
            </ButtonSecondary>
        </form>
    );
};

export default ContactFormLightweight;